module.exports = __webpack_public_path__ + "img/lalanita_home_top_one.87530b50.png";